import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'ac-nav-header-skeleton',
	templateUrl: './header-skeleton.component.html',
	styleUrls: ['./header-skeleton.component.scss']
})
export class HeaderSkeletonComponent implements OnInit {
	@Input() public elements = 5;
	@Input() public gridClass = 'grid-980';

	public GHOST_ELEMENTS;

	public ngOnInit(): void {
		this.GHOST_ELEMENTS = Array(this.elements).fill(0);
	}

}
